import { render } from "./ProductDetail_AiAudit.vue?vue&type=template&id=60e72236&scoped=true"
import script from "./ProductDetail_AiAudit.vue?vue&type=script&lang=js"
export * from "./ProductDetail_AiAudit.vue?vue&type=script&lang=js"

import "./ProductDetail_AiAudit.vue?vue&type=style&index=0&id=60e72236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e72236"]])

export default __exports__